import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { clone } from 'lodash-es';
import { Store } from '@ngrx/store';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'vb-colorpicker',
  templateUrl: './colorpicker.component.html',
  styleUrls: ['./colorpicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ColorpickerComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false  //NOSONAR
})
export class ColorpickerComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private utilService = inject(UtilService);

  @Input() element: any;
  @Input() formControlName: any;
  @Input() disableField = false;
  private modelValue: any;
  hslColor: any;
  hexColor: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  disabled: boolean;
  color: string;
  predefinedColors: any[] = [
    { hex: '#E544FF', hsl: 'hsl(292,100%,63%)' },
    { hex: '#8220FF', hsl: 'hsl(266,100%,56%)' },
    { hex: '#1A73E8', hsl: 'hsl(214,82%,51%)' },
    { hex: '#16D3FD', hsl: 'hsl(191,98%,54%)' },
    { hex: '#00D7A3', hsl: 'hsl(165,100%,42%)' },
    { hex: '#9CD3AB', hsl: 'hsl(136,38%,72%)' },
    { hex: '#99CF00', hsl: 'hsl(76,100%,41%)' },
    { hex: '#E8D205', hsl: 'hsl(54,96%,46%)' },
    { hex: '#FCD48B', hsl: 'hsl(39,95%,77%)' },
    { hex: '#FF6B00', hsl: 'hsl(25,100%,50%)' },
    { hex: '#F6A09D', hsl: 'hsl(2,83%,79%)' },
    { hex: '#FF4DA2', hsl: 'hsl(331,100%,65%)' }
  ];
  selectedColor: string;
  setPreviousPrimaryValue = '';
  setPreviousSecondaryValue = '';
  @Output() changedColor = new EventEmitter<string>();
  // currentPage: any = null;
  @Input() currentPage: any;
  isTemplate = false;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setSelectedColor(value);
    this.modelValue = value;
    // console.log(value)
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setSelectedColor(value: any) {
    if (value && typeof value === 'string') {
      this.color = clone(value);
      this.selectedColor = value;
    }
  }

  selectColor(color?: any) {
    // this.selectedColor = color;
    if (this.currentPage?.currentPage === 'templates') {
      this.color = color?.hex ? color?.hex : this.utilService.hslToHex(color);
      if (this.color.length > 7) {
        this.color = this.color.slice(0, 7);
      }
    } else {
      this.color = color?.hex || color;
    }
    /* this.modelValue = this.selectedColor;
    this.onChange(this.modelValue); */
  }

  changeColor() {
    // this.selectedColor = this.color;
    /*  this.modelValue = this.selectedColor;
     this.onChange(this.modelValue); */
  }

  saveSelectedColor(event: any, op: any) {
    if (this.currentPage?.currentPage === 'templates') {
      this.selectedColor = this.color;
      if (this.currentPage?.currentPage === 'templates') {
        this.hslColor = this.utilService.hexToHsl(this.color);
        this.color = this.hslColor;
      }
    }
    this.changedColor.emit(this.color);
    op.hide(event);
    /* if (this.color === '#1a73e8')
      this.setPreviousPrimaryValue = this.color;
    if (this.color === '#ffff')
      this.setPreviousSecondaryValue = this.color; */
    if (this.formControlName === '$primary-color') {
      if (this.color?.toLowerCase() === this.element?.defaultValue?.toLowerCase()) {
        this.setPreviousPrimaryValue = this.color;
      }
      const obj: any = {
        color: this.color,
        prevValue: this.setPreviousPrimaryValue,
        name: this.element.name,
        originalDefaultColor: this.element?.defaultValue
      };
      //this.changedColor.emit(obj);
      this.setPreviousPrimaryValue = this.color;
    } else if (this.formControlName === '$secondary-color') {
      if (this.color?.toLowerCase() === this.element?.defaultValue?.toLowerCase()) {
        this.setPreviousSecondaryValue = this.color;
      }
      const obj: any = {
        color: this.color,
        prevValue: this.setPreviousSecondaryValue,
        name: this.element.name,
        originalDefaultColor: this.element?.defaultValue
      };
      //this.changedColor.emit(obj);
      this.setPreviousSecondaryValue = this.color;
    }
    if (!this.color) {
      this.color = '#ffffff';
      this.selectedColor = '#ffffff';
    }
    this.setSelectedColor(this.color);
    this.onChange(this.color);
  }

  cancelSelColor(event: any, op: any) {
    op.hide(event);
    this.color = this.selectedColor;
  }

  ngOnInit(): void {
    // this.listenForPageChange();
    if (this.element?.name?.toLowerCase() === '$primary-color') {
      this.setPreviousPrimaryValue = this.element?.defaultValue;
    }
    if (this.element?.name?.toLowerCase() === '$secondary-color') {
      this.setPreviousSecondaryValue = this.element?.defaultValue;
    }
  }

  // listenForPageChange() {
  //   let currPageSub = this.store.select(currentPage).subscribe((page: any) => {
  //     this.currentPage = page;
  //     if (this.currentPage?.currentPage==='template') {
  //      this.isTemplate = true;
  //     }
  //   })
  // }
  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }

  repositon(event) {
    if (!event?.clientY) {
      return;
    }
    setTimeout(() => {
      const el: any = $('.color-picker-overlay');
      let style = $(el[0]).attr('style') ?? '';
      if (event.clientY - 400 < 0) {
        style += 'top:75px!important;';
        style += `left:${event.x - 264}px!important;`;
        $(el[0]).attr('style', style);
        let className = $(el[0]).attr('class') ?? '';
        className += ' arrow-right';
        $(el[0]).attr('class', className);
        const customArrow = $(el).find('.custom-arrow');
        className = $(customArrow[0]).attr('class') ?? '';
        className += ' custom-arrow-right';
        $(customArrow[0]).attr('class', className);
        style = $(customArrow[0]).attr('style') ?? '';
        style += `top:${event.clientY - 75}px!important;`;
        style += 'left:100%!important;';
        $(customArrow[0]).attr('style', style);
      } else {
        style += `top:${event.clientY - 400}px!important`;
        $(el[0]).attr('style', style);
        const customArrow = $(el).find('.custom-arrow');
        let className = $(el[0]).attr('class');
        className = $(customArrow[0]).attr('class') ?? '';
        className += ' custom-arrow-top';
        $(customArrow[0]).attr('class', className);
        style = $(customArrow[0]).attr('style') ?? '';
        style += `top:${event.clientY - 12}px!important;`;
        style += 'left:100%!important;';
        $(customArrow[0]).attr('style', style);
      }
    }, 0);
  }
}
